export default __webpack_public_path__ + "static/media/sanmat7.bdbde653.jpg";